module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-SemiBoldItalic-88cad1873b4b05c75a99d768150b2394.woff";